import { useState } from "react"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import HomeIcon from "@mui/icons-material/Home"
import MenuItem from "@mui/material/MenuItem"
import Menu from "@mui/material/Menu"
import Breadcrumbs from "./Breadcrumbs"
import { useLocation, useNavigate } from "react-router-dom"
// import UserAvatar from './UserAvatar'
import useLogout from "../../hooks/useLogout"
import { useThemeMode } from "../../contexts/ThemeContext"
import { ListItemIcon, useMediaQuery, useTheme } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import LogoutIcon from "@mui/icons-material/Logout"
import DarkModeIcon from "@mui/icons-material/DarkMode"
import ColorLensIcon from "@mui/icons-material/ColorLens"
import LightModeIcon from "@mui/icons-material/LightMode"
import MenuIcon from "@mui/icons-material/Menu"
import NotificationsIcon from "@mui/icons-material/Notifications"
import { Badge } from "@mui/material"
import { useSearch } from "../../contexts/SearchContext"
import SearchBar from "./SearchBar"
import NotificationModal from "../../components/Notifications/NotificationModal"
import useNotifications from "../../components/Notifications/useNotifications"

export default function BarMenu() {
    const [anchorEl, setAnchorEl] = useState(null)
    const [notifOpen, setNotifOpen] = useState(false)
    const navigate = useNavigate()
    const { logout } = useLogout()
    const { unreadCount } = useNotifications()
    const { toggleTheme, mode, scheme, changeScheme } = useThemeMode()
    const location = useLocation()
    const { search, setSearch } = useSearch()
    const theme = useTheme()

    const bigScreen = useMediaQuery(theme.breakpoints.up("sm"))

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    function handleProfileClick() {
        navigate(`/User Profile`)
        handleClose()
    }

    async function handleLogout() {
        await logout()
        navigate("/", { replace: true })
    }

    // Show SearchBar only on /ports and /portdatalist
    const showSearch =
        location.search.length === 0 && location.pathname.startsWith("/ports")

    return (
        <Box
            sx={{
                mb: 3,
                flexGrow: 1,
                backgroundColor: "transparent",
                position: "sticky",
                top: 0,
                zIndex: "appBar",
            }}
        >
            <AppBar
                position="static"
                sx={{ maxHeight: { sm: 55 }, width: "100%" }}
            >
                <Toolbar
                    sx={{
                        minHeight: { sm: 50 },
                        justifyContent: "space-between",
                    }}
                >
                    <IconButton
                        size="large"
                        edge="start"
                        color="text.primary"
                        aria-label="menu"
                        sx={{ justifySelf: "center" }}
                        onClick={() => navigate("/ports")}
                    >
                        <HomeIcon />
                    </IconButton>
                    {(bigScreen || !showSearch) && <Breadcrumbs />}

                    {showSearch && (
                        <SearchBar
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={
                                location.pathname.startsWith("/ports/")
                                    ? "Search Data..."
                                    : "Search Ports..."
                            }
                        />
                    )}
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <IconButton
                            size="large"
                            aria-label="notifications"
                            onClick={() => setNotifOpen(true)}
                            color="inherit"
                        >
                            <Badge
                                badgeContent={unreadCount}
                                color="error"
                                max={99}
                            >
                                <NotificationsIcon
                                    sx={{ color: "text.primary" }}
                                />
                            </Badge>
                        </IconButton>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                            sx={{ fontSize: "large" }}
                        >
                            {/* <UserAvatar
                                firstName={auth?.firstName}
                                lastName={auth?.lastName}
                                bar={40}
                            /> */}
                            <MenuIcon
                                sx={{
                                    color: "text.primary",
                                    width: "1.4em",
                                    height: "1.4em",
                                }}
                            />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleProfileClick}>
                                <ListItemIcon>
                                    <PersonIcon />
                                </ListItemIcon>
                                Profile
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    const next =
                                        scheme === "default"
                                            ? "rose"
                                            : scheme === "rose"
                                              ? "mint"
                                              : scheme === "mint"
                                                ? "sunset"
                                                : "default"
                                    changeScheme(next)
                                }}
                            >
                                <ListItemIcon>
                                    <ColorLensIcon />
                                </ListItemIcon>
                                Theme:{" "}
                                {scheme === "default"
                                    ? "Default"
                                    : scheme.charAt(0).toUpperCase() +
                                      scheme.slice(1)}
                            </MenuItem>
                            <MenuItem onClick={toggleTheme}>
                                <ListItemIcon>
                                    {mode === "dark" ? (
                                        <LightModeIcon />
                                    ) : (
                                        <DarkModeIcon />
                                    )}
                                </ListItemIcon>
                                {mode === "dark" ? "Light" : "Dark"} Mode
                            </MenuItem>
                            <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutIcon />
                                </ListItemIcon>
                                Logout
                            </MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <NotificationModal
                open={notifOpen}
                onClose={() => setNotifOpen(false)}
            />
        </Box>
    )
}
